import { message } from "antd";
import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { Card, Form, FormGroup, Modal, ModalBody, Spinner } from "reactstrap";
import { AllowAccess } from "../../../components/BlockAccess";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PaginationComponent,
} from "../../../components/Component";
import { FaqTable } from "../../../components/table/SpecialTable";
import { authHeader } from "../../../header";
import { useDebounce } from "../../../hooks/useDebounceSearch";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";

export const FaqManagement = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    answer: "",
    faqCategory: "",
    question: "",
    status: "",
  });
  const [editId, setEditId] = useState();
  const [isLoadBtn, setIsLoadBtn] = useState(false);
  const [modal, setModal] = useState({ add: false, edit: false, view: false });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);
  const [faqs, setFaqs] = useState([]);
  const [details, setDetails] = useState({});
  const [categories, setCategories] = useState([]);
  const [search, setSearch] = useState("");

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const debouncedSearchTerm = useDebounce(search, 500);

  useEffect(
    () => {
      // if (debouncedSearchTerm) {
      getAllFaq();
      setCurrentPage(1);
      // }v
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onEditClick = async (item) => {
    setModal({ edit: true });
    setFormData({
      answer: item.answer,
      status: item.status,
      question: item.question,
      faqCategory: item.faqCategory.id,
      id: item.id,
      platform: "TREASURY",
    });
    setEditId(item.id);
  };

  const onViewClick = (item) => {
    setModal({ view: true });
    setDetails({
      answer: item.answer,
      status: item.status,
      question: item.question,
      faqCategory: item.faqCategory.name,
      id: item.id,
    });
  };

  const getAllFAQCategory = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/faq-category?platform=TREASURY`, {
        headers: authHeader(),
      });
      const { data } = response;
      if (data) {
        setCategories(data.data.body.filter((cat) => cat.status === "ACTIVE"));
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllFAQCategory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAllFaq = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/auth/faq?platform=TREASURY&search=${search}`,
        {
          headers: authHeader(),
        }
      );
      const { data } = response;
      if (data) {
        setFaqs(data.data.body);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const addFaq = async (obj) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/admin/faq`, obj, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        message.success({
          content: "FAQ Created Successfully",
        });
        getAllFaq();
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ add: false });
        resetForm();
      }
      return { formData };
    } catch (error) {
      const message = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      setModal({ add: false });
      resetForm();
      return { message };
    }
  };

  const editFaq = async (obj) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/auth/admin/faq/${editId}`, obj, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        message.success({
          content: "FAQ Updated Successfully",
        });
        getAllFaq();
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ add: false });
        resetForm();
      }
      return { formData };
    } catch (error) {
      const message = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      setModal({ add: false });
      resetForm();
      return { message };
    }
  };

  const onFormSubmit = () => {
    addFaq({ ...formData, platform: "TREASURY" });
    resetForm();
    setModal({ add: false });
  };

  const onEditSubmit = () => {
    editFaq({ ...formData, platform: "TREASURY" });
    resetForm();
    setModal({ edit: false });
  };

  const resetForm = () => {
    setFormData({
      name: "",
      description: "",
      status: "",
    });
  };

  const onFormCancel = () => {
    setModal({ edit: false, add: false });
    resetForm();
  };

  const { errors, register, handleSubmit } = useForm();

  useEffect(() => {
    getAllFaq();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = faqs?.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  return (
    <React.Fragment>
      <Head title="Manage FAQ"></Head>
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <div className="d-flex justify-content-between align-items-center">
                <BlockTitle tag="h4">FAQ Management</BlockTitle>
                <div className="d-flex align-items-center justify-center">
                  <div className="mr-2">
                    <input
                      className="form-control"
                      value={search}
                      onChange={handleSearchChange}
                      placeholder="Search FAQ..."
                    />
                  </div>
                  <AllowAccess allowedRights={["CREATE_FAQ"]}>
                    <Button color="primary" onClick={() => setModal({ add: true })}>
                      <Icon name="plus"></Icon>
                      <span>Add FAQ</span>
                    </Button>
                  </AllowAccess>
                </div>
              </div>
            </BlockHeadContent>
          </BlockHead>
          <Card className="card-bordered card-preview">
            {isLoading ? (
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                  margin: "0 auto",
                }}
              />
            ) : (
              <FaqTable data={currentItems} onViewClick={onViewClick} modal={modal} onEditClick={onEditClick} />
            )}
          </Card>
          <div className="card-inner">
            {faqs && faqs.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={faqs?.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No Category found</span>
              </div>
            )}
          </div>
        </Block>

        <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Add FAQ</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">FAQ Category</label>
                      <select
                        className="form-control"
                        name="faqCategory"
                        onChange={(e) => onInputChange(e)}
                        ref={register({
                          required: "This field is required",
                        })}
                      >
                        <option value="">Select FAQ Category</option>
                        {categories.map((cat, _idx) => (
                          <option value={cat.id}>{cat.name}</option>
                        ))}
                      </select>
                      {errors.faqCategory && <span className="invalid">{errors.faqCategory.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Question</label>
                      <input
                        type="text"
                        name="question"
                        placeholder="FAQ Question"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.question && <span className="invalid">{errors.question.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <FormGroup>
                      <label className="form-label">FAQ Answer</label>
                      <textarea
                        name="answer"
                        defaultValue={formData.answer}
                        placeholder="Enter FAQ Answer"
                        onChange={(e) => onInputChange(e)}
                        className="form-control-xl form-control no-resize"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.answer && <span className="invalid">{errors.answer.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <select
                        className="form-control"
                        name="status"
                        onChange={(e) => onInputChange(e)}
                        ref={register({
                          required: "This field is required",
                        })}
                      >
                        <option value="">Select Status</option>
                        <option value="ACTIVE">ACTIVE</option>
                        <option value="INACTIVE">INACTIVE</option>
                      </select>
                      {errors.status && <span className="invalid">{errors.status.message}</span>}
                      {/* <label className="form-label">Status</label> */}
                      {/* <RSelect options={status} onChange={(e) => setFormData({ ...formData, status: e.value })} /> */}
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button color="primary" size="md" type="submit">
                          {isLoadBtn ? <Spinner size="sm" /> : "Submit"}
                        </Button>
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal.view} toggle={() => setModal({ view: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">View FAQ: {details?.question ?? ""}</h5>
              <div className="mt-4">
                <Col md="12" className="w-100 d-flex p-0 my-2">
                  <Col md="6">
                    <span style={{ fontSize: "1rem" }} className="font-weight-bold mr-1">
                      Faq Category:
                    </span>
                    <span style={{ fontSize: "0.9rem" }}>{details?.faqCategory ?? ""}</span>
                  </Col>
                  <Col md="6">
                    <span style={{ fontSize: "1rem" }} className="font-weight-bold mr-1">
                      Status:
                    </span>
                    <span style={{ fontSize: "0.9rem" }}>{details.status ?? ""} </span>
                  </Col>
                </Col>
                <Col md="12" className="my-2">
                  <span style={{ fontSize: "1rem" }} className="font-weight-bold mr-1">
                    FAQ Question:
                  </span>
                  <span style={{ fontSize: "0.9rem" }}>{details.question ?? ""} </span>
                </Col>
                <Col md="12" className="my-2">
                  <span style={{ fontSize: "1rem" }} className="font-weight-bold mr-1">
                    FAQ Answer:
                  </span>
                  <span style={{ fontSize: "0.9rem" }}>{details.answer ?? ""} </span>
                </Col>
                <Col size="12">
                  <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                    <li>
                      <Button
                        onClick={(ev) => {
                          ev.preventDefault();
                          onFormCancel();
                        }}
                        className="link link-light"
                      >
                        Cancel
                      </Button>
                    </li>
                  </ul>
                </Col>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal.edit} toggle={() => setModal({ edit: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Edit FAQ</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onEditSubmit)}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">FAQ Category</label>
                      <select
                        className="form-control"
                        name="faqCategory"
                        value={formData.faqCategory}
                        onChange={(e) => onInputChange(e)}
                        ref={register({
                          required: "This field is required",
                        })}
                      >
                        <option value="">Select FAQ Category</option>
                        {categories.map((cat, _idx) => (
                          <option value={cat.id}>{cat.name}</option>
                        ))}
                      </select>
                      {errors.faqCategory && <span className="invalid">{errors.faqCategory.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Question</label>
                      <input
                        type="text"
                        name="question"
                        placeholder="FAQ Question"
                        value={formData.question}
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.question && <span className="invalid">{errors.question.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <FormGroup>
                      <label className="form-label">FAQ Answer</label>
                      <textarea
                        name="answer"
                        value={formData.answer}
                        placeholder="Enter FAQ Answer"
                        onChange={(e) => onInputChange(e)}
                        className="form-control-xl form-control no-resize"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.answer && <span className="invalid">{errors.answer.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <select
                        className="form-control"
                        name="status"
                        value={formData.status}
                        onChange={(e) => onInputChange(e)}
                        ref={register({
                          required: "This field is required",
                        })}
                      >
                        <option value="">Select Status</option>
                        <option value="ACTIVE">ACTIVE</option>
                        <option value="INACTIVE">INACTIVE</option>
                      </select>
                      {errors.status && <span className="invalid">{errors.status.message}</span>}
                      {/* <label className="form-label">Status</label> */}
                      {/* <RSelect options={status} onChange={(e) => setFormData({ ...formData, status: e.value })} /> */}
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button color="primary" size="md" type="submit">
                          {isLoadBtn ? <Spinner size="sm" /> : "Submit"}
                        </Button>
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};
